var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"category-tag"},[_c('span',[_vm._v(_vm._s(_vm.model.name))]),_c('a',{staticClass:"category-remove",on:{"click":function($event){$event.preventDefault();return _vm.remove.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-times"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }